<template>
  <div v-if="panel.fields.length > 0" v-show="visibleFieldsCount > 0">
      <div class="flex items-center mb-3" v-if="resourceName === 'promotions'">
          <h1 class="font-normal text-xl md:text-xl mb-3 flex-auto">{{ panel.name }}</h1>
          <div class="ml-3 flex items-center">
              <ButtonInertiaLink
                  class="mr-2 shrink-0 h-9 px-4 focus:outline-none ring-primary-200 dark:ring-gray-600 focus:ring text-white dark:text-gray-800 inline-flex items-center font-bold"
                  dusk="create-button"
                  :href="
        $url(`/resources/promotions`)
      "
              >
          <span class="inline-block">
        {{ capitalizedResourceName }}
      </span>
              </ButtonInertiaLink>
          </div>
      </div>

    <Heading
        v-else
      :level="1"
      :class="panel.helpText ? 'mb-2' : 'mb-3'"
      :dusk="`${dusk}-heading`"
    >
      {{ panel.name }}
    </Heading>

    <p
      v-if="panel.helpText"
      class="text-gray-500 text-sm font-semibold italic mb-3"
      v-html="panel.helpText"
    />

    <Card class="divide-y divide-gray-100 dark:divide-gray-700">
      <component
        v-for="(field, index) in panel.fields"
        :index="index"
        :key="index"
        :is="`form-${field.component}`"
        :errors="validationErrors"
        :resource-id="resourceId"
        :resource-name="resourceName"
        :related-resource-name="relatedResourceName"
        :related-resource-id="relatedResourceId"
        :field="field"
        :via-resource="viaResource"
        :via-resource-id="viaResourceId"
        :select-info="selectInfo"
        :select-info-date="selectInfoDate"
        :via-relationship="viaRelationship"
        :shown-via-new-relation-modal="shownViaNewRelationModal"
        :form-unique-id="formUniqueId"
        :mode="mode"
        @field-shown="handleFieldShown"
        @field-hidden="handleFieldHidden"
        @field-changed="$emit('field-changed')"
        @file-deleted="handleFileDeleted"
        @file-upload-started="$emit('file-upload-started')"
        @file-upload-finished="$emit('file-upload-finished')"
        :show-help-text="showHelpText"
      />
    </Card>
  </div>
</template>

<script>
import { HandlesPanelVisibility, mapProps } from '@/mixins'
import ButtonInertiaLink from "../../components/Buttons/ButtonInertiaLink.vue";

export default {
  name: 'FormPanel',
    components: {ButtonInertiaLink},

  mixins: [HandlesPanelVisibility],

  emits: [
    'field-changed',
    'update-last-retrieved-at-timestamp',
    'file-deleted',
    'file-upload-started',
    'file-upload-finished',
  ],

  props: {
    ...mapProps(['mode']),
    shownViaNewRelationModal: { type: Boolean, default: false },
    showHelpText: { type: Boolean, default: false },
    panel: { type: Object, required: true },
    name: { default: 'Panel' },
    dusk: { type: String },
    fields: { type: Array, default: [] },
    formUniqueId: { type: String },
    validationErrors: { type: Object, required: true },
    resourceName: { type: String, required: true },
    resourceId: { type: [Number, String] },
    relatedResourceName: { type: String },
    relatedResourceId: { type: [Number, String] },
    viaResource: { type: String },
    viaResourceId: { type: [Number, String] },
    viaRelationship: { type: String },
      selectInfo: { type: Object, default: null },
      selectInfoDate: { type: Object, default: null }
  },

  methods: {
    handleFileDeleted() {
      this.$emit('update-last-retrieved-at-timestamp')
    },
  },
    computed: {
        capitalizedResourceName() {
            return this.resourceName.charAt(0).toUpperCase() + this.resourceName.slice(1);
        }
    }
}
</script>
